import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text/text';
import {RightPanelOverlayHeader} from '@FormMakerReact/layout/form-maker-right-panel/components/right-panel-overlay-header/right-panel-overlay-header';
import {ShortcutRow} from './components/shortcut-row/shortcut-row';
import {KEYBOARD_SHORTCUT_SECTIONS, type KeyboardShortcutsViewProps, type ShortcutRowConfig, type ShortcutSectionConfig} from './keyboard-shortcuts-view.types';
import styles from './keyboard-shortcuts-view.module.scss';

export function KeyboardShortcutsView({onBack}: KeyboardShortcutsViewProps): ReactElement {
  return (
    <>
      <RightPanelOverlayHeader title={window.i18next.t('pmwjs_keyboard_shortcuts')} backAriaLabel={window.i18next.t('pmwjs_back')} onBack={onBack} />
      <div>{KEYBOARD_SHORTCUT_SECTIONS.map(renderSection)}</div>
    </>
  );
}

function renderSection(section: ShortcutSectionConfig, idx: number): ReactElement {
  return (
    <div key={idx} className={styles.section}>
      <Text val={window.i18next.t(section.titleKey)} size={TextSize.MD} bold className={styles.sectionTitle} />
      {section.rows.map(renderRow)}
    </div>
  );
}

function renderRow(row: ShortcutRowConfig, idx: number): ReactElement {
  return <ShortcutRow key={idx} label={window.i18next.t(row.labelKey)} keys={row.keys} />;
}
